import PermitFormStep1 from './PermitFormStep1';
import PermitFormStep2 from './PermitFormStep2';
import PermitFormStep3 from './PermitFormStep3';
import PermitFormStep6FinalReview from './PermitFormStep6FinalReview';
import { PermitFormValues } from '../../../../app/models/permit';
import { observer } from 'mobx-react-lite';
import PermitFormStep4 from './PermitFormStep4';
import PermitFormStep5 from './PermitFormStep5';
import PermitFormStep0 from './PermitFormStep0';
import { getButtonSize } from '../../../../app/common/util/util';

interface Props {
    step: number,
    values: PermitFormValues,
    next: () => void,
    prev: () => void,
    goTo: (step: number) => void,
    handleChange: (name: string|any, value: string|object|boolean) => void,
    handleDropdownChange: (e: React.ChangeEvent<HTMLInputElement>, data: any) => void,
    handleFinalFormSubmit: (values: PermitFormValues) => void
}

export default observer(function PermitFormSteps({ 
    step, values, next, prev, goTo, handleChange, handleDropdownChange, handleFinalFormSubmit
 }: Props) {
    const buttonSize = getButtonSize();

    switch (step) {
        case 0:
            return <PermitFormStep0 values={values} next={next} buttonSize={buttonSize} />
        case 1:
            return <PermitFormStep1 values={values}
                handleChange={handleChange} next={next}
                handleDropdownChange={handleDropdownChange}
                goTo={goTo}
                buttonSize={buttonSize}
            />
        case 2:
            return <PermitFormStep2 values={values} 
                handleChange={handleChange} next={next} prev={prev} goTo={goTo} buttonSize={buttonSize}
            />
        case 3:
            return <PermitFormStep3 values={values} next={next} prev={prev} goTo={goTo} buttonSize={buttonSize}
            />
        case 4:
            return <PermitFormStep4 values={values} 
                handleChange={handleChange} next={next} prev={prev} goTo={goTo} buttonSize={buttonSize}
            />
        case 5:
            return <PermitFormStep5 values={values}
                handleChange={handleChange} next={next} prev={prev} goTo={goTo} buttonSize={buttonSize}
            />
        case 6:
            return <PermitFormStep6FinalReview values={values} goTo={goTo} handleFinalFormSubmit={handleFinalFormSubmit} buttonSize={buttonSize}
            />
        default:
            return <>Empty</>
    }
})